export interface ChatMessage {
    message: string,
    role: ChatMessageRole,
    timestamp?: number
}

export enum ChatMessageRole {
    User = 'User',
    Model = 'Model'
}

export interface NotifyHostRequest {
    elementId: string;
    status: string;
    complianceIssues: ComplianceIssue[];
}

export interface ComplianceIssue {
    description: string;
    codeReference: string;
    severity: string;
    recommendedAction: string;
}

export interface Article {
  title: string;
  articleContent: string;
  explanation: string;
  conclusion: string;
  conclusionType: 'valid' | 'invalid' | 'undetermined' | 'not-applicable' | 'unknown';
}

export interface ParsedData {
  articles: Article[];
  overallConclusion: string;
  overallConclusionType: 'valid' | 'invalid' | 'undetermined' | 'not-applicable' | 'unknown';
}